import React from 'react';
import { Beaker, Gauge, Activity, Palette } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import ContactStrip from '../components/ContactStrip';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';

const icons = [Beaker, Gauge, Activity, Palette];

const QualityCriteria = () => {
  const { t, lang } = useLang();
  const criteria = t('quality.criteria');
  const seo = getSeo('quality', lang);

  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/quality-criteria" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={t('quality.label')} title={t('quality.title')} lead={t('quality.lead')} imageKey="labTest2" />
      <section className="bg-white py-16 lg:py-24">
        <div className="container-wide grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {criteria.map((c, i) => {
            const Icon = icons[i] || Beaker;
            return (
              <Reveal key={i} delay={i * 80}>
                <article className="h-full flex gap-5 p-6 lg:p-8 rounded-xl bg-white border border-slate-200 hover:border-blue-300 hover:shadow-md hover:shadow-blue-700/5 transition">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-blue-700/5 border border-blue-700/15 text-blue-700 shrink-0">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-slate-900 leading-snug">{c.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default QualityCriteria;
